import FlexPane from 'presentation/components/flex-pane/index.js';
import DateTime from 'presentation/components/date-time/index.js';
import ParticipantsBoard from 'presentation/components/scoreboard/participants-board/index.js';
import NeutralVenueIndicator from 'presentation/components/neutral-venue-indicator';

const PreplayScoreboard = props => {
    const {
        event,
        showEventIndicators,
        mojitoTools: { config },
    } = props;

    if (!event) {
        return <div className="PreplayScoreboard" />;
    }

    return (
        <FlexPane config={config.container} class="PreplayScoreboard">
            {showEventIndicators && (
                <FlexPane config={config.dateTimeWrapper}>
                    <DateTime dateTime={event.startTime} config={config.dateTime} />
                    {event.neutral && (
                        <NeutralVenueIndicator config={config.neutralVenueIndicator} />
                    )}
                </FlexPane>
            )}
            <ParticipantsBoard config={config.participantsBoard} event={event} />
        </FlexPane>
    );
};

export default PreplayScoreboard;
